import type { EditorMode } from "./TopBar";
import { BlockEditor } from "./BlockEditor";
import { SourceEditor } from "./SourceEditor";
import { useEditorStore } from "@/store/editorStore";
import type { CanvasLook } from "@/lib/themes/look";

interface EditorPanelProps {
  mode: EditorMode;
  showSourceTabs: boolean;
  /** Bumped by EditorPage on every save success so SourceEditor
   *  refetches the LaTeX from the server. Other modes ignore it. */
  sourceRefreshKey?: number;
  /** The document theme on the canvas (null = Classic). */
  look?: CanvasLook | null;
}

export function EditorPanel({
  mode,
  showSourceTabs,
  sourceRefreshKey = 0,
  look = null,
}: EditorPanelProps) {
  const documentId = useEditorStore((s) => s.documentId);

  if (mode === "source") {
    return <SourceEditor documentId={documentId!} refreshKey={sourceRefreshKey} />;
  }

  return (
    <BlockEditor
      showSourceTabs={showSourceTabs}
      look={look}
    />
  );
}
